export default function PageHeader({title}){
    return (
        <div className="h-[15vmin] w-full bg-[#f5f5f5] flex justify-start items-center relative mobile-page-header">
            <h1 className="top-[50%] left-[50%] transform translate-center absolute w-full text-center teal text-[4vmin] exo-2-bold tracking-widest">{title}</h1>
        </div>
    );
}